<template>
  <pano-container :xml="xml">
    <div class="page-title" v-if="query.title">{{ query.title }}</div>
    <img
      v-if="Number(query.is_has_ex)"
      src="../../travel/images/ai_btn.png"
      class="travel-animate-fade-down ai-btn"
      @click="toGoods"
    />
  </pano-container>
</template>

<script>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import qs from "@halobear/utils/qs";

import { xml as getXml } from "@/api/pano";

import PanoContainer from "@/components/pano-container";

export default {
  components: {
    PanoContainer,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const query = computed(() =>
      route.query.hotel_id
        ? route.query
        : qs.parse(window.location.search.split("?")[1] || "")
    );

    const xml = computed(() => {
      const { hotel_id = 0, hall_id = 0 } = query.value;
      return getXml({ hotel_id, hall_id });
    });

    const toGoods = () => {
      router.replace({
        name: "insideGoods",
        query: { ...query.value },
      });
    };

    return {
      query,
      xml,
      toGoods,
    };
  },
};
</script>

<style lang="less" scoped>
.page-title {
  width: 750px;
  height: 92px;
  line-height: 92px;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.36) 51%,
    rgba(0, 0, 0, 0) 100%
  );
  text-align: center;
  color: white;
  font-size: 32px;
  font-weight: bold;
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  margin: auto;
}

.ai-btn {
  width: 120px;
  height: 140px;
  position: fixed;
  bottom: 92px;
  right: 20px;
  z-index: 100;
  cursor: pointer;
}
@keyframes slideFadeDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.travel-animate-fade-down {
  animation: slideFadeDown ease 1s both;
}
</style>